import React from "react";
import WelcomeCard from "./WelcomeCard";

const Home = ({ therapists }) => {
  return (
    <div>
      {/* <UpdateCard /> */}
      <WelcomeCard therapists={therapists} />
    </div>
  );
};
export default Home;
